<template>
  <div class="home">
    <MDPage path="/home.md"></MDPage>
  </div>
</template>

<script>

import MDPage from "@/components/MDPage.vue"

export default {
  name: "home",
  components: {
    MDPage
  }
};
</script>

<style scoped>
.inline {
  background-color: black;
  color: white;
  border-radius: 1em;
  padding: 0.8em;
  font-size: 1.3em;
}
</style>